import { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import AccionaBigUploadButton from '../../../../../components/AccionaBigUploadButton';
import {
  deliveryNotesFileExtensions,
  laboratoryFileExtensions,
} from '../../../../../constants/general';
import {
  createFileOnBackend,
  preprocessFile,
} from '../../../../../services/api/files';
import Modal from '../../../../../components/Modal';
import styles from './index.module.scss';
import { MainContext } from '../../../../../context/MainContext';
import { PDFDocument } from 'pdf-lib';

const { buttons } = styles;

const UploadDocumentModal = ({
  setUploadModel,
  setTemplate,
  setFileName,
  setModel,
  showModal,
  setShowModal,
  pid,
}) => {
  const intl = useIntl();
  const { setLoading, setError, setShowUploadDelayInfo } =
    useContext(MainContext);

  const getMessage = (response) => {
    let message;

    if (!response) {
      return 'Unknown document';
    }
    switch (response) {
      case 'not found template':
        message = 'notFound';
        break;
      default:
        message = response;
    }

    return message;
  };

  const extractFirstPageFromPdf = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const originalPdf = await PDFDocument.load(arrayBuffer);

    const newPdf = await PDFDocument.create();
    const [firstPage] = await newPdf.copyPages(originalPdf, [0]);
    newPdf.addPage(firstPage);

    const newPdfBytes = await newPdf.save();
    return new Blob([newPdfBytes], { type: 'application/pdf' });
  };

  const fileSelectedHandler = async (event, model, ref) => {
    const files = event.target.files;
    const allowedFileExtensions =
      model === 'delivery'
        ? deliveryNotesFileExtensions
        : laboratoryFileExtensions;
    const firstFileExtension = files?.[0].name.split('.').pop();
    const isASingleXlsxFile =
      files?.length === 1 && firstFileExtension === 'xlsx';
    setShowModal(false);
    if (files?.length === 1 && !isASingleXlsxFile) {
      //Comprueba que el fichero introducido sea correcto
      let file = files[0];
      if (
        allowedFileExtensions.includes(file.name.split('.').pop().toLowerCase())
      ) {
        setLoading(true);
        const arrayBuffer = await file.arrayBuffer();
        const originalPdf = await PDFDocument.load(arrayBuffer);
        const pageCount = originalPdf.getPageCount();
        setShowUploadDelayInfo(pageCount >= 3);
        if (
          model === 'laboratory' &&
          file.name.endsWith('.pdf') &&
          pageCount > 1
        ) {
          file = new File([await extractFirstPageFromPdf(file)], file.name, {
            type: 'application/pdf',
          });
        }

        createFileOnBackend(file, model, pid, false)
          .then(({ data }) => {
            //Creamos y almacenamos el fichero
            setLoading(false);
            setShowUploadDelayInfo(false);
            if (!data.suppliers) {
              setLoading(false); //Redirigimos a la página create con el fichero subido
              setTemplate(data.template);
              setFileName(data.fileName);
              setModel(model);
            } else {
              const tempFiles = [];

              for (const i in data.suppliers) {
                tempFiles.push({
                  name: (
                    <FormattedMessage
                      id="page"
                      values={{
                        number: Number(i) + 1,
                      }}
                    />
                  ),
                  status: 'sucess',
                  template: (
                    <FormattedMessage id={getMessage(data.suppliers[i])} />
                  ),
                });
              }
              setUploadModel({
                files: tempFiles,
                total: data.suppliers.length,
                uploading: false,
                model: `title.${model}`,
              });
            }
          })
          .catch((error) => {
            setLoading(false);
            setError({
              status: error.response ? error.response.status : 502,
              errorType: 'UPLOAD_FILE_ERROR',
            });
          });
      } else {
        setError({
          status: 415,
          errorType: 'UPLOAD_FILE_ERROR',
        });
      }
    } else if (files?.length > 1 || isASingleXlsxFile) {
      const tempFiles = [];
      for (const file of files) {
        tempFiles.push({
          name: file.name,
          status: 'waiting',
          template: <FormattedMessage id="waiting" />,
        });
      }
      setUploadModel({
        files: tempFiles,
        total: files.length,
        uploading: true,
        model: `title.${model}`,
      });
      for (const [index, file] of Object.entries(files)) {
        try {
          setUploadModel((prev) => {
            prev.files[index] = {
              name: file.name,
              status: 'uploading',
              template: <FormattedMessage id="searching" />,
            };
            return { ...prev };
          });
          const response = await preprocessFile(file, model, pid);
          if (response.data) {
            let msg;
            if (response.data.suppliers) {
              // msg = (
              //   <>
              //     {response.data.suppliers.reduce(
              //       (acc, msg, index) => (
              //         <>
              //           {acc}
              //           {index > 0 && ', '}
              //           <FormattedMessage key={index} id={getMessage(msg)} />
              //         </>
              //       ),
              //       <></>,
              //     )}{' '}
              //     {/* Inicializa con <></> en lugar de '' */}
              //   </>
              // );
              msg = (
                <>
                  {response.data.suppliers.map((msg, index) => (
                    <div key={index}>
                      {intl.formatMessage(
                        { id: 'page' }, // ID de la traducción para "Página X"
                        { number: index + 1 }, // Sustituye {number} en la traducción
                      )}
                      : <FormattedMessage id={getMessage(msg)} />
                    </div>
                  ))}
                </>
              );
              console.info(msg);
            } else {
              msg = <FormattedMessage id={getMessage(response.data)} />;
            }
            setUploadModel((prev) => {
              prev.files[index] = {
                name: file.name,
                status: 'sucess',
                template: msg,
              };
              return { ...prev };
            });
          }
        } catch (e) {
          setUploadModel((prev) => {
            prev.files[index] = {
              name: file.name,
              status: 'error',
              template: 'Error',
            };
            return { ...prev };
          });
        }
      }
      setUploadModel((prev) => {
        return { ...prev, uploading: false };
      });
      if (document.getElementById(ref)) {
        document.getElementById(ref).value = [];
      }
    }
  };

  return (
    <Modal
      open={showModal}
      onCancel={() => setShowModal(false)}
      width="28vw"
      backgroundColor="#f1f1f1"
      closable
    >
      <div className={buttons}>
        <AccionaBigUploadButton
          icon="delivery-ocr"
          type="deliveryNote"
          id="uploadDelivery"
          onClick={(event) =>
            fileSelectedHandler(event, 'delivery', `fileSelector_delivery-ocr`)
          }
          msg={intl.formatMessage({ id: `scan.document.delivery` })}
        />
        <AccionaBigUploadButton
          icon="laboratory-ocr"
          type="laboratory"
          id="uploadLaboratory"
          onClick={(event) =>
            fileSelectedHandler(
              event,
              'laboratory',
              `fileSelector_laboratory-ocr`,
            )
          }
          msg={intl.formatMessage({ id: `scan.document.laboratory` })}
        />
      </div>
    </Modal>
  );
};

UploadDocumentModal.propTypes = {
  setUploadModel: PropTypes.func.isRequired,
  setTemplate: PropTypes.func.isRequired,
  setFileName: PropTypes.func.isRequired,
  setModel: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  pid: PropTypes.string.isRequired,
};

export default UploadDocumentModal;
